// extracted by mini-css-extract-plugin
module.exports =  {"root":"ofJfxhhpRpBBzwBU1FGD"};